import { createAuthMiddleware } from '@tshio/redux-api-auth-middleware';
import contentMiddleware from '@tshio/redux-api-content-middleware';
import createEndpointMiddleware from '@tshio/redux-api-endpoint-middleware';
import paramsMiddleware from '@tshio/redux-api-params-middleware';
import { AuthenticationActions } from 'react-aad-msal';
import { AnyAction, applyMiddleware, combineReducers, compose, createStore as reduxCreateStore, Reducer } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { devToolsEnhancer } from 'redux-devtools-extension/logOnlyInProduction';
import { getEnvironmentVar } from 'utils';

import { AuthState } from './store.types';

const endpointMiddleware = createEndpointMiddleware({
  apis: {
    default: {
      apiUrl: getEnvironmentVar('REACT_APP_ADMIN_SERVICE_API_URL'),
      credentials: 'omit',
    },
  },
});

const authMiddleware = createAuthMiddleware({
  authConfig: {
    header: 'Authorization',
    type: 'Bearer',
  },
});

const middlewares = [endpointMiddleware, contentMiddleware, paramsMiddleware, authMiddleware, apiMiddleware];

const initialState: any = {
  accessToken: null,
};

const oauthReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case AuthenticationActions.AcquiredAccessTokenSuccess:
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };
    default:
      return state;
  }
};

export const createStore = () =>
  reduxCreateStore(
    combineReducers({
      auth: oauthReducer as Reducer<AuthState, AnyAction>,
    }),
    {
      auth: {
        accessToken: undefined,
      },
    },
    compose(
      applyMiddleware(...middlewares),
      devToolsEnhancer({ name: 'Primary' }),
    ),
  );
